import { render, staticRenderFns } from "./SelectInsurance.vue?vue&type=template&id=13bb3a38&"
import script from "./SelectInsurance.vue?vue&type=script&lang=js&"
export * from "./SelectInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports